import { Checkbox, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import useStore from 'store'
import { getSchoolLabels } from 'servers/searchSchool'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { ISchoolLabels } from 'servers/searchSchool/interface'
import s from './index.module.less'

/**
 * sourceType: volunteer ->填志愿  search-> 查学校  专科只支持查学校和查专业不支持填报 故筛选器公共组件做区分
 *
 */

const FillCheck: React.FC<{ hasAuth: boolean; sourceType: string }> = ({ hasAuth, sourceType }) => {
  const [renderList, setRenderList] = useState<ISchoolLabels[]>()
  const { state, dispatch } = useStore()
  const { filterParamsData } = state
  const listMap = {
    provinceList: '所在地区',
    schoolTypes: '院校类型',
    schoolTags: sourceType === 'volunteer' ? '院校层次' : '院校特色',
    schoolTypeAttribute: '办学性质',
    eduLevel: '学历层次'
  }

  const onChange = (e, type) => {
    if (!hasAuth) {
      dispatch({ type: 'updateFillModalVisible', payload: true })
      return
    }
    const { target } = e
    const { checked, value } = target
    if (value === '不限' && checked) {
      dispatch({
        type: 'updateFilterParamsData',
        payload: { collegeParam: { ...state.filterParamsData.collegeParam, [type]: [] }, page: 1 }
      })
    } else {
      // 办学性质特殊处理
      dispatch({
        type: 'updateFilterParamsData',
        payload: {
          collegeParam: {
            ...state.filterParamsData.collegeParam,
            [type]: state.filterParamsData.collegeParam
              ? checked
                ? [...(state.filterParamsData.collegeParam[type] || []), value]
                : state.filterParamsData.collegeParam[type]?.filter((v) => v !== value)
              : [value]
          },
          page: 1
        }
      })
    }
  }

  const getSearchParams = async () => {
    const { data } = await getSchoolLabels(sourceType === 'volunteer' ? 1 : 2)
    setRenderList(data)
  }

  useEffect(() => {
    getSearchParams()
  }, [])

  return (
    <div className={s.FillCheck}>
      {renderList?.map((v) => (
        <section className={s.content} key={v.labelType}>
          <p className={s.title}>{listMap[v.labelType]}</p>
          <section className={`${s.checkbox} fillCheckbox`}>
            <Checkbox
              onChange={(e) => onChange(e, v.labelType)}
              checked={
                !(
                  filterParamsData.collegeParam &&
                  filterParamsData.collegeParam[v.labelType]?.length
                )
              }
              value="不限"
              key="不限"
            >
              不限
            </Checkbox>
            {v.schoolLabels.map((i) => (
              <Checkbox
                onChange={(e) => onChange(e, v.labelType)}
                value={i.labelName}
                key={i.labelName}
                checked={
                  (filterParamsData.collegeParam &&
                    filterParamsData.collegeParam[v.labelType]?.indexOf(i.labelName) > -1) ||
                  (i.mustSelect && sourceType === 'volunteer')
                }
                disabled={i.mustSelect && sourceType === 'volunteer'}
              >
                {typeof i === 'string' ? (
                  i
                ) : (
                  <>
                    {i.labelName}
                    {i.tip && (
                      <Tooltip
                        title={i.tip}
                        arrowPointAtCenter
                        overlayClassName={s.tooltip}
                        overlayInnerStyle={{
                          background: 'rgba(4, 8, 18, 0.7)',
                          padding: 6,
                          maxWidth: 270,
                          color: '#fff'
                        }}
                      >
                        <QuestionCircleOutlined />
                      </Tooltip>
                    )}
                    {i.hasSplitter && <>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;</>}
                  </>
                )}
              </Checkbox>
            ))}
          </section>
        </section>
      ))}
    </div>
  )
}

export default FillCheck
